module.exports = __webpack_public_path__ + "img/1434248101.53fb16df.jpg";